import './resizer.component.scss';
import { Component, Input, OnInit, Inject, OnChanges, EventEmitter, Output } from 'ng-metadata/core';

/**
* @ngdoc directive
* @name mwResizer
* @module mw.components.resizer
*
* @param {string} [resizable-target='mw-resizable'] - Element selector used for identifying the element that should be resized
* @param {expression} [on-resize] - This event is triggered when the handler bar is dragged.
* @param {expression} [on-resize-start] - This event is triggered as soon as the handler bar is dragged.
* @param {expression} [on-resize-end] - This event is triggered when the drag is stopped.
*
* @description
* `<mw-resizer>` is a component used to trigger resizing a container element when the user drags the resize handle
*
* @usage
* <hljs hljs-language="html">
 *   <div class="mw-resizable" style="height: 100px; min-height: 100px; max-height: 300px;">
 *     <mw-resizer></mw-resizer>
 *   </div>
* </hljs>
*
*/

@Component({
    selector: 'mw-resizer',
    template: `
        <div mw-touch-start="$ctrl.handleResize()" class="mw-resizer"
            draggable="false"
            ondragstart="return false" ondragenter="event.dataTransfer.dropEffect='none'; event.stopPropagation(); event.preventDefault();"
            ondragover="event.dataTransfer.dropEffect='none';event.stopPropagation(); event.preventDefault();"
            ondrop="event.dataTransfer.dropEffect='none';event.stopPropagation(); event.preventDefault();">
            <md-icon md-svg-icon="navigation:ic_more_horiz_24px"></md-icon>
        </div>
    `
})
export class ResizerComponent implements OnInit {

    @Input('@') resizableTarget: string;

    @Output() onResize = new EventEmitter<number>();
    @Output() onResizeStart = new EventEmitter<number>();
    @Output() onResizeEnd = new EventEmitter<number>();

    private originalHeight: number = 0;

    constructor(
        @Inject('$element') private $element: ng.IRootElementService,
        @Inject('$timeout') private $timeout
    ) {
        'ngInject'
    }

    ngOnInit() {
    }

    handleResize() {
        const target = this.$element[0].closest(this.resizableTarget || '.mw-resizable');
        let initialPageY: number;
        let currentHeight: number;

        if (!target) {
          return
        }

        const initialHeight = target.getBoundingClientRect().height;
        document.body.style.userSelect = 'none';
        document.body.style.msUserSelect = 'none';
        this.onResizeStart.emit(initialHeight);

        const handleMouseMove = (e: MouseEvent | TouchEvent) => {
            const currentYPos = e.pageY || e.touches[0].pageY;

            initialPageY = initialPageY || currentYPos;
            currentHeight = initialHeight + (currentYPos - initialPageY);

            window.requestAnimationFrame(() => {
                target.style.height = `${currentHeight}px`;
            });

            this.onResize.emit(currentHeight);
        }

        const handleMouseUp = () => {
          document.removeEventListener('mousemove', handleMouseMove);
          document.removeEventListener('mouseup', handleMouseUp);
          document.removeEventListener('touchend', handleMouseUp);
          document.removeEventListener('touchmove', handleMouseMove);
          this.onResizeEnd.emit(currentHeight);
        }

        document.addEventListener('mouseup', handleMouseUp);
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('touchend', handleMouseUp);
        document.addEventListener('touchmove', handleMouseMove);
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/resizer/resizer.component.ts